// let hostName = 'http://192.168.5.107:8080' // 本地
let hostName = 'https://zsy-dev.tsycvip.com' // 测试
// let hostName = 'http://192.168.5.109:8080' // 正式

// 本地预览优先走本机 CMS（需先启动 cms-master）；否则走线上
const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");
let apiServer = isLocalHost
  ? "http://localhost:5000/"
  : "https://cms.kzspp.com/";
// let apiServer = 'http://192.168.5.108:8801/api' // 本地旧地址
// let apiServer = 'https://cms.kzspp.com/' // 线上

// 站点信息（SEO/GEO 统一使用，改域名时只改这里）
const siteUrl = 'https://www.kuangzhen.com.cn';
const siteName = '湖南旷真律师事务所';

export {
    hostName,
    apiServer,
    siteUrl,
    siteName,
}